import { Divider } from "@mui/material"

const GoalCardDivider = () => {
    return <Divider orientation="vertical" flexItem sx={{opacity: "0.75"}}/>
}
export default GoalCardDivider;